/* eslint-disable max-classes-per-file */
import {
    BaseError,
} from 'wanderu-utils';

export class CognitoUnableToAuthenticateUserError extends BaseError {
    constructor() {
        super('Cognito unable to authenticate user.');
        this.name = 'CognitoUnableToAuthenticateUserError';
    }
}

export class CreateAccountValidationError extends BaseError {
    constructor() {
        super('Validation error');
        this.name = 'CreateAccountValidationError';
    }
}

export class EmailNotFoundError extends BaseError {
    constructor() {
        super('Email address not found.');
        this.name = 'EmailNotFoundError';
    }
}

export class ExpiredCodeError extends BaseError {
    constructor(email) {
        super('The code has expired.');
        this.name = 'ExpiredCodeError';
        this.email = email;
    }
}

export class FacebookUnableToAuthenticateUserError extends BaseError {
    constructor() {
        super('Facebook unable to authenticate user.');
        this.name = 'FacebookUnableToAuthenticateUserError';
    }
}

export class GeneralLoginError extends BaseError {
    constructor() {
        super('General login error');
        this.name = 'GeneralLoginError';
    }
}
export class GoogleSDKFailedToLoadError extends BaseError {
    constructor() {
        super('Google SDK failed to load.');
        this.name = 'GoogleSDKFailedToLoadError';
    }
}

export class GoogleUnableToAuthenticateUserError extends BaseError {
    constructor() {
        super('Google unable to authenticate user.');
        this.name = 'GoogleUnableToAuthenticateUserError';
    }
}

export class InactiveAccountError extends BaseError {
    constructor() {
        super('Cannot reset password for the user as there is no registered/verified email or phone number');
        this.name = 'InactiveAccountError';
    }
}

export class InvalidPasswordError extends BaseError {
    constructor() {
        super('One of the passwords were invalid. Please change passwords and try again');
        this.name = 'InvalidPasswordError';
    }
}

export class LimitExceededError extends BaseError {
    constructor() {
        super('Attempt limit exceeded. Please try again later.');
        this.name = 'LimitExceededError';
    }
}

export class LoginFailedUseThirdPartyError extends BaseError {
    constructor() {
        super('User created account with 3rd party and should log in with that.');
        this.name = 'LoginFailedUseThirdPartyError';
    }
}

export class UnableToAutoAuthenticateUserError extends BaseError {
    constructor() {
        super('Unable to auto authenticate user.');
        this.name = 'UnableToAutoAuthenticateUserError';
    }
}

export class UnableToRetrieveTicketError extends BaseError {
    constructor() {
        super('Unable to retrieve the ticket.');
        this.name = 'UnableToRetrieveTicketError';
    }
}

export class UserAlreadyExistsError extends BaseError {
    constructor() {
        super('User already exists.');
        this.name = 'UserAlreadyExistsError';
    }
}

export class UserEmailNotVerifiedError extends BaseError {
    constructor() {
        super('User\'s email is not verified');
        this.name = 'UserEmailNotVerifiedError';
    }
}

export class UserNotConfirmedError extends BaseError {
    constructor() {
        super('User is not confirmed');
        this.name = 'UserNotConfirmedError';
    }
}

export class UserNotLoggedInError extends BaseError {
    constructor() {
        super('User not logged in.');
        this.name = 'UserNotLoggedInError';
    }
}
